<template>
  <simple-page class="h-100 bg-primary">
    <div class="col-md-8 col-lg-6">
      <!--
      ==========================================================================
      Page header
      ==========================================================================
      -->
      <h2 class="text-white text-center">
        <i class="fa fa-fw fa-lock"></i>
        {{ $env.app.name }}
      </h2>

      <!--
      ==========================================================================
      Flash message
      ==========================================================================
      -->
      <b-alert v-if="flash" show :variant="flashVariant">
        {{ flash }}
      </b-alert>

      <!--
      ==========================================================================
      Page body
      ==========================================================================
      -->
      <b-card-group class="rounded-lg box-shadow-dark">
        <!--
        ==========================================================================
        Image
        ==========================================================================
        -->
        <b-card class="d-none d-md-block border-0 bg-cover bg-login">
        </b-card>
        <!--
        ==========================================================================
        Form
        ==========================================================================
        -->
        <b-card>
          <editor @logged-in="loggedIn" />
          <b-button
            v-if="$env.app.offlineSupport"
            variant="link"
            block
            :to="$route.query.redirect || defaultRoute">
            {{ $t('login.actions.proceed') }}
          </b-button>
        </b-card>
      </b-card-group>
      <!--
      ==========================================================================
      Page footer
      ==========================================================================
      -->
      <div class="text-right mt-2">
        <router-link
          class="font-decoration-none text-white font-weight-bold"
          :to="{ name: 'ResetPassword' }">
          {{ $t('login.actions.resetPassword') }}
        </router-link>
      </div>
    </div>
  </simple-page>
</template>
<script>
import FlashMessageSupportMixin from 'vue-template/common/mixins/FlashMessageSupportMixin';
import editor from "vue-template/public/editors/LoginEditor";

export default {
  mixins: [FlashMessageSupportMixin],

  components: {
    editor
  },

  props: {
    defaultRoute: {
      type: [String, Object],
      default: '/'
    },
  },

  methods: {
    loggedIn(/*result*/) {
      this.$router.push(this.$route.query.redirect || this.defaultRoute);
    }
  }
};
</script>
